import transformEcheancesFacturation from '@/services/bodac/client/budget/transformEcheancesFacturation';
import { getAll, getBudgetTotalHt } from '@/api/echeanceFacturation/index';
import * as allTypes from '@/store/mutation-type';
import genererCriteresRechercheLigneARenouveler from '@/services/echeanceFacturation/genererCriteresRechercheEcheanceFacturation';
import formatDate from '@/services/general/formatIsoDate';
import * as types from './EcheanceFacturation-mutation-type';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    montantTotalHt: 0,
    criteresRecherche: genererCriteresRechercheLigneARenouveler(),
    lastPayload: {},
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, count) {
    state.totalCount = count;
  },
  [types.SET_MONTANT_TOTAL_HT](state, montantTotalHt) {
    state.montantTotalHt = montantTotalHt;
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [types.SET_LAST_PAYLOAD](state, lastPayload) {
    state.lastPayload = lastPayload;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadEcheances({ commit }, data) {
    data.query.dates.dateDebut = formatDate(data.query.dates.dateDebut);
    data.query.dates.dateFin = formatDate(data.query.dates.dateFin);
    data.query.groupeIds = data.query.groupeIds.map(g => g.id);
    data.query.enseigneIds = data.query.enseigneIds.map(e => e.id);
    data.query.pointDeVenteIds = data.query.pointDeVenteIds.map(p => p.id);
    const echeances = (await getAll(data)).data.result;
    const echeancesTransformees = transformEcheancesFacturation(echeances.items);
    commit(types.SET_LAST_PAYLOAD, data);
    commit(types.SET_ITEMS, echeancesTransformees);
    commit(types.SET_TOTAL, echeances.totalCount);
    const montant = (await getBudgetTotalHt(data)).data.result;
    commit(types.SET_MONTANT_TOTAL_HT, montant);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  montantTotalHt: state => {
    return state.montantTotalHt;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
